exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tblClass[data-v-c7105654]{border-collapse:collapse}.tblClass tr td[data-v-c7105654],.tblClass tr th[data-v-c7105654]{border:1px solid #ccc;padding:8px 0}.textCenter[data-v-c7105654],.textCenter tr td[data-v-c7105654],.textCenter tr th[data-v-c7105654]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c7105654","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/training/training_information/detailsView.vue
// module id = 1267
// module chunks = 3